import { useTranslations } from 'next-intl';

import { css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';
import { Drawer } from '@flipster/ui';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}

const CollateralValueRatioBottomSheet = ({ isOpen, onClose, onExit }: Props) => {
  const t = useTranslations();

  return (
    <Drawer
      title={t('Autogen_common.r251126.s_Collateral_value_ratio')}
      isShow={isOpen}
      onClose={onClose}
      onExit={onExit}
      round
      position='bottom'
      noPadding
    >
      <div className={flex({ px: 16, pb: 40 })}>
        <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-5' })}>
          The collateral value ratio shows how much of an asset is recognized as collateral.
          <br />
          For example, if BTC has a ratio of 95%, then 95 USDT out of 100 USDT worth of BTC is counted as collateral.
        </p>
      </div>
    </Drawer>
  );
};

export default CollateralValueRatioBottomSheet;
